import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=68c7b83c&scoped=true&lang=pug"
import script from "./TeamMembers.vue?vue&type=script&lang=js"
export * from "./TeamMembers.vue?vue&type=script&lang=js"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&id=68c7b83c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7b83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c7b83c')) {
      api.createRecord('68c7b83c', component.options)
    } else {
      api.reload('68c7b83c', component.options)
    }
    module.hot.accept("./TeamMembers.vue?vue&type=template&id=68c7b83c&scoped=true&lang=pug", function () {
      api.rerender('68c7b83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/dashboard/TeamMembers.vue"
export default component.exports